module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Pendências de bancas")])])], 1), _vm._v(" "), (_vm.loading) ? _c('v-card-text', [_vm._v(" Carregando pendências... ")]) : _vm._e(), _vm._v(" "), (_vm.errors.length) ? _c('v-card-text', _vm._l((_vm.errors), function(error, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "error": "",
        "value": "true"
      }
    }, [_vm._v("\n      " + _vm._s(error) + "\n    ")])
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.pendencies), function(pendency) {
    return _c('v-card', {
      key: pendency.id,
      staticClass: "ma-3"
    }, [_c('v-card-title', [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('strong', [_vm._v("Banca " + _vm._s(pendency.id) + " - " + _vm._s(pendency.title))]), _c('br'), _vm._v("\n        " + _vm._s(_vm.formatDate(pendency.date)) + " · Curso: " + _vm._s(pendency.courseName) + " ·\n        Presidente: " + _vm._s(pendency.chairName) + "\n      ")])], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "pendency-chips",
      class: {
        'pendency-chips--active': _vm.canOpenActions
      }
    }, [(pendency.finalScorePending) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white"
      }
    }, [(_vm.canOpenActions) ? _c('router-link', {
      staticClass: "white--text",
      attrs: {
        "to": {
          name: 'examDetail',
          params: {
            id: pendency.id
          }
        }
      }
    }, [_vm._v("Nota pendente")]) : _c('span', [_vm._v("Nota pendente")])], 1) : _vm._e(), _vm._v(" "), (pendency.attendancePending) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white",
        "link": _vm.canOpenActions
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.canOpenActions && _vm.showExamAttendance(pendency.id)
        }
      }
    }, [_vm._v("\n        Presenças/ausências pendentes\n      ")]) : _vm._e(), _vm._v(" "), (pendency.certificationPending) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white",
        "link": _vm.canOpenActions
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.canOpenActions && _vm.showExamAttendance(pendency.id)
        }
      }
    }, [_vm._v("\n        Certificações pendentes\n      ")]) : _vm._e(), _vm._v(" "), (pendency.minutesPending) ? _c('v-chip', {
      class: {
        'cursor-pointer': _vm.canOpenActions
      },
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.canOpenActions && _vm.showExamDocuments(pendency.id)
        }
      }
    }, [_vm._v("\n        Ata pendente\n      ")]) : _vm._e(), _vm._v(" "), (pendency.closingPending) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white"
      }
    }, [(_vm.canOpenActions) ? _c('router-link', {
      staticClass: "white--text",
      attrs: {
        "to": {
          name: 'examDetail',
          params: {
            id: pendency.id
          }
        }
      }
    }, [_vm._v("Encerramento pendente")]) : _c('span', [_vm._v("Encerramento pendente")])], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (!_vm.loading && !_vm.errors.length && !_vm.pendencies.length) ? _c('v-card-text', [_vm._v("\n    Não há bancas com pendências.\n  ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.attendanceDialog),
      callback: function($$v) {
        _vm.attendanceDialog = $$v
      },
      expression: "attendanceDialog"
    }
  }, [_c('exam-attendance', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.attendanceDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.documentsDialog),
      callback: function($$v) {
        _vm.documentsDialog = $$v
      },
      expression: "documentsDialog"
    }
  }, [_c('exam-documents', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.documentsDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d42a22a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamPendency.vue
// module id = 249
// module chunks = 0